var chunkMapping = {
	"34": [
		828,
		1557,
		2391,
		2777,
		3580,
		5620,
		5894,
		6744,
		9518,
		9684
	],
	"394": [
		559,
		917,
		1012,
		1335,
		1681,
		1760,
		2147,
		2567,
		2591,
		2710,
		2945,
		2948,
		2951,
		3542,
		4686,
		4963,
		5195,
		6467,
		6586,
		6708,
		6765,
		7090,
		7113,
		7298,
		7599,
		7693,
		7994,
		8122,
		8491,
		8513,
		8618,
		8739,
		9255,
		9266,
		9493,
		9771
	],
	"576": [
		137,
		2844,
		3991,
		5479,
		5637,
		9283,
		9523
	],
	"592": [
		7381
	]
};
var idToExternalAndNameMapping = {
	"137": [
		"default",
		"./register",
		7883
	],
	"559": [
		"default",
		"./Page",
		8359
	],
	"828": [
		"default",
		"./UnboxingPageIntroduction",
		8230
	],
	"917": [
		"default",
		"./icons/Filter",
		8359
	],
	"1012": [
		"default",
		"./Col",
		8359
	],
	"1335": [
		"default",
		"./Text",
		8359
	],
	"1557": [
		"default",
		"./icons/MagnetUnboxing",
		8359
	],
	"1681": [
		"default",
		"./Divider",
		8359
	],
	"1760": [
		"default",
		"./Statistic",
		8359
	],
	"2147": [
		"default",
		"./Menu",
		8359
	],
	"2391": [
		"default",
		"./UnboxingPageHeader",
		8230
	],
	"2567": [
		"default",
		"./hooks",
		8230
	],
	"2591": [
		"default",
		"./Tooltip",
		8359
	],
	"2710": [
		"default",
		"./Row",
		8359
	],
	"2777": [
		"default",
		"./Image",
		8359
	],
	"2844": [
		"default",
		"./icons/Message",
		8359
	],
	"2945": [
		"default",
		"./ButtonWithDropdown",
		8359
	],
	"2948": [
		"default",
		"./Card",
		8359
	],
	"2951": [
		"default",
		"./FilterBar",
		8359
	],
	"3542": [
		"default",
		"./Table",
		8359
	],
	"3580": [
		"default",
		"./UnboxingPageBody",
		8230
	],
	"3991": [
		"default",
		"./icons/Science",
		8359
	],
	"4686": [
		"default",
		"./MenuItem",
		8359
	],
	"4963": [
		"default",
		"./History",
		1441
	],
	"5195": [
		"default",
		"./Space",
		8359
	],
	"5479": [
		"default",
		"./icons/Push",
		8359
	],
	"5620": [
		"default",
		"./UnboxingPageRow",
		8230
	],
	"5637": [
		"default",
		"./icons/Email",
		8359
	],
	"5894": [
		"default",
		"./UnboxingPageCol",
		8230
	],
	"6467": [
		"default",
		"./hooks",
		1441
	],
	"6586": [
		"default",
		"./Tag",
		8359
	],
	"6708": [
		"default",
		"./Panel",
		8359
	],
	"6744": [
		"default",
		"./UnboxingPage",
		8230
	],
	"6765": [
		"default",
		"./Avatar",
		8359
	],
	"7090": [
		"default",
		"./icons/Winner",
		8359
	],
	"7113": [
		"default",
		"./Option",
		8359
	],
	"7298": [
		"default",
		"./charts/Column",
		8359
	],
	"7381": [
		"default",
		"./cWrapper",
		1441
	],
	"7599": [
		"default",
		"./notification",
		8359
	],
	"7693": [
		"default",
		"./Selectors",
		1441
	],
	"7994": [
		"default",
		"./StatisticCard",
		8359
	],
	"8122": [
		"default",
		"./LookEmbed",
		5296
	],
	"8491": [
		"default",
		"./icons/InfoCircle",
		8359
	],
	"8513": [
		"default",
		"./Icon",
		8359
	],
	"8618": [
		"default",
		"./Button",
		8359
	],
	"8739": [
		"default",
		"./Collapse",
		8359
	],
	"9255": [
		"default",
		"./Skeleton",
		8359
	],
	"9266": [
		"default",
		"./Select",
		8359
	],
	"9283": [
		"default",
		"./unboxing-page",
		8230
	],
	"9493": [
		"default",
		"./icons/InfoCircleOutlined",
		8359
	],
	"9518": [
		"default",
		"./UnboxingPageDocumentation",
		8230
	],
	"9523": [
		"default",
		"./icons/AltRoute",
		8359
	],
	"9684": [
		"default",
		"./UnboxingPageCrossSelling",
		8230
	],
	"9771": [
		"default",
		"./GameSelectorUtils",
		1441
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}